export function TableMixinFactory (
    {
        filterHeaderFunc = null,
        filterItemFunc = null,
        headerMapFunc = null,
        itemMapFunc = null
    } = {}) {
    const defaultFilterHeaderFunc = (header, isExcluded) => {
        return isExcluded
    }
    const defaultFilterItemFunc = () => {
        return true
    }
    const defaultHeaderMapFunc = (header) => {
        return header
    }
    const defaultItemMapFunc = (item) => {
        return item
    }

    const _filterHeaderFunc = filterHeaderFunc ?? defaultFilterHeaderFunc
    const _filterItemFunc = filterItemFunc ?? defaultFilterItemFunc
    const _headerMapFunc = headerMapFunc ?? defaultHeaderMapFunc
    const _itemMapFunc = itemMapFunc ?? defaultItemMapFunc

    return {
        props: {
            items: {
                type: Array,
                default: () => []
            },

            excludeHeaders: {
                type: Array,
                default: () => []
            },

            editable: {
                type: Boolean,
                default: false
            },

            options: {
                type: Object,
                default: () => ({})
            }
        },

        data () {
            return {
                headers: []
            }
        },

        computed: {
            processedHeaders () {
                return this.headers?.filter(header => {
                    const isExcluded = !this.excludeHeaders?.some(exclHeader => exclHeader === header.value)
                    return _filterHeaderFunc(header, isExcluded)
                })?.map(_headerMapFunc.bind(this))
            },

            processedItems () {
                return this.items?.filter(_filterItemFunc.bind(this))?.map(_itemMapFunc.bind(this))
            }
        },

        methods: {
            onRowItemClick (item) {
                this.$emit('viewDetails', item)
            }
        }
    }
}

export default TableMixinFactory()
